












































































































import Vue from 'vue'
import { IVW } from '@/types/model'
import easyapi from '@/easyapi'
import { dev_property_t } from '@/store/modules/pref'
import { DeviceType, VideoOutMode } from '@/types/api'
import VwPreviewScreen from '@/components/VwPreviewScreen.vue'
import { whenWindowResized, getDevSeries } from '@/utils'
import mixins from 'vue-typed-mixins'
import { vwDialogMixin } from '@/mixins'


export default mixins(vwDialogMixin).extend({
  components: {
    VwPreviewScreen,
  },
  data () {
    return {
      getDevSeries: getDevSeries,
      previewScreenWidth: 0,
    }
  },
  computed: {
    vw (): IVW | null {   // Fix the bizarre broken reference of Vuex
      if (!this.dialog.vw) {return null}
      const id = this.dialog.vw.id
      return this.$s.device.getters.vwList.find(x => x.id === id) || null
    }
  },
  methods: {
    adjustScreenSize () {
      const el = this.$refs.previewRow
      if (el instanceof Element) {
        this.previewScreenWidth = el.clientWidth
      }
    },
    toggleActive () {
      if (!this.vw) {return}
      easyapi.applyVw(this.vw.id)
    },
    openDisplayIndexDialog () {
      if (!this.vw) {return}
      this.$router.push({ name: 'vwlst_details_showidx', params: { vwid: this.vw.id + '' }})
    },
    openRenameDialog () {
      if (!this.vw) {return}
      this.$router.push({ name: 'vwlst_details_rename', params: { vwid: this.vw.id + '' }})
    },
    openVendorDialog () {
      if (!this.vw) {return}
      this.$router.push({ name: 'vwlst_details_vendor', params: { vwid: this.vw.id + '' }})
    },
    openResizeDialog () {
      if (!this.vw) {return}
      this.$router.push({ name: 'vwlst_details_resize', params: { vwid: this.vw.id + '' }})
    },
    openRxListDialog () {
      if (!this.vw) {return}
      this.$router.push({ name: 'vwlst_details_rxmap', params: { vwid: this.vw.id + '' } })
    },
    openTxListDialog () {
      if (!this.vw) {return}
      this.$router.push({ name: 'vwlst_details_txmap', params: { vwid: this.vw.id + '' } })
    },
  },
  watch: {
    vw (newVal) {
      if (!newVal) { return }
      Vue.nextTick(this.adjustScreenSize)
      whenWindowResized(this.adjustScreenSize)  // TODO: REFACTORING: use $state.common.windowSize
    }
  },
  mounted () {
    //
  }
})
